import { render, staticRenderFns } from "./SelectCompanyProductCategories.vue?vue&type=template&id=992769b6&"
import script from "./SelectCompanyProductCategories.vue?vue&type=script&lang=js&"
export * from "./SelectCompanyProductCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports